var global = require('../internals/global');
var isRegExp = require('../internals/is-regexp');

var TypeError = global.TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/not-a-regexp.js